/* global axios */
import ApiClient from '../ApiClient';

class NexceoKanbanStagesAPI extends ApiClient {
  constructor() {
    super('nexceo/projects', { accountScoped: true });
  }

  // Fetch all stages for the account (used by Kanban board)
  getAll(params = {}) {
    const base = this.url.replace('/nexceo/projects', '/nexceo/all_stages');
    return axios.get(base, { params });
  }

  list(projectId) {
    return axios.get(`${this.url}/${projectId}/kanban_stages`);
  }

  create(projectId, data) {
    return axios.post(`${this.url}/${projectId}/kanban_stages`, data);
  }

  update(projectId, stageId, data) {
    return axios.patch(
      `${this.url}/${projectId}/kanban_stages/${stageId}`,
      data
    );
  }

  delete(projectId, stageId) {
    return axios.delete(`${this.url}/${projectId}/kanban_stages/${stageId}`);
  }
}

export default new NexceoKanbanStagesAPI();
